import type { FC } from 'react';
import Modal from 'react-bootstrap/Modal';
import { PersonCheck, PersonX } from 'react-bootstrap-icons';

import 'react-datepicker/dist/react-datepicker.css';

import { TemporaryAccessCodeStatus } from '../../../modules/enums/status';

type DeleteModalProp = {
  show: boolean;
  onHide: () => void;
  title: string;
  description: string;
  onDisabled: (tempAccessCodeStatus: TemporaryAccessCodeStatus) => void;
  isTempAccessCodeDisabled?: TemporaryAccessCodeStatus;
};

const EditTemporaryAccessCodeStatus: FC<DeleteModalProp> = ({
  show,
  onHide,
  onDisabled,
  title,
  description,
  isTempAccessCodeDisabled,
}) => {
  const getButtonTitle = () => {
    if (isTempAccessCodeDisabled === TemporaryAccessCodeStatus.DISABLED) {
      return 'Yes, enable';
    }

    return 'Yes, disable';
  };

  const disabledHandler = () => {
    if (isTempAccessCodeDisabled === TemporaryAccessCodeStatus.DISABLED) {
      onDisabled(TemporaryAccessCodeStatus.ENABLED);
    } else {
      onDisabled(TemporaryAccessCodeStatus.DISABLED);
    }
  };

  return (
    <Modal
      className="modal-delete-view-style"
      show={show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        {title === 'Do you want to activate this user?' ? (
          <PersonCheck size={50} />
        ) : (
          <PersonX size={50} />
        )}
        <div className="delete-info-text-style">{title}</div>
        <div className="delete-info-remove-text-style">{description}</div>
        <div className="delete-btn-container">
          <div className="delete-btn-cancal-style" onClick={onHide}>
            Cancel
          </div>
          <div className="delete-info-btn-detele-style" onClick={() => disabledHandler()}>
            {getButtonTitle()}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditTemporaryAccessCodeStatus;
